// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
// Components, Layouts, Pages
import { JobDocumentsTemplate } from '~/pages/template';
import { DocumentLocal } from '~/components/module/document';
// Others
import { IFolderLocal } from '~/utils/interface/document';
import { IFormJob, IPhotoAttachmentJob } from '~/utils/interface/job';
import { BusinessTypeEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './CreateJobAttachment.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const CreateJobAttachment = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { control, setValue } = useFormContext<IFormJob>();
  const { id: jobId } = useParams();
  const folders = useWatch({ control, name: 'folders' });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChange = (data: IFolderLocal[]) => {
    const formatData: IPhotoAttachmentJob[] = data.map((folder) => {
      return {
        name: folder.name,
        isCurrentApply: folder.isCurrentApply,
        files: folder?.files?.map((file) => {
          return {
            url: file.url,
            fieldName: file.fieldName,
            size: file.size,
            mimetype: file.mimetype,
            name: file.name,
          };
        }),
      };
    });
    setValue('folders', formatData, { shouldDirty: true });
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='createJobAttachmentComponent' className={cx('container')}>
      {jobId ? (
        <JobDocumentsTemplate />
      ) : (
        <DocumentLocal
          id={jobId}
          folders={folders}
          onChange={handleChange}
          businessType={BusinessTypeEnum.JOB}
        />
      )}
    </Box>
  );
};

export default CreateJobAttachment;
